import React from 'react';
import ProjectTemplate from '../components/ProjectTemplate';

const RipplePage = () => {

    const media = 
    [
        '/images/orbit_1.webp', 
        '/images/orbit_2.webp'
    ];

  return (
    <div className="orbit-page">
      
 <ProjectTemplate
title="ripple"
year="2021"
  sections={[
    {
      type: 'description',
      text: 
    <p>
      ripple is a wave-terrain sound synthesis model based on properties of water. It allows for playful experimentation with the sonified manifestation of interference patterns. One can do so by placing sources and modulating its position and frequency. ripple formed the basis for the work
      <a href="/projects/---"  rel="noopener noreferrer">- - -</a>
    </p>
    },
    {
      type:'video',
      links: ['https://www.youtube.com/embed/2WXWR4J4wPI?si=stGJgAcrSgswLzI4?controls=1&modestbranding=1&rel=0&showinfo=0']
    }, 
    // {
    //   type: 'image', 
    //   links: 
    //   [
    //     {
    //         src: media[0]
    //     }      
    // ],
    //   isLink: false, 
    // },
    // {
    //     type: 'image', 
    //     links: 
    //     [
    //         {
    //             src: media[1]
    //         }        
    //     ],
    //     isLink: false, 
    // }
  ]}
  
/>

    </div>
  );
};

export default RipplePage;
